export const SET_TAB = '@search/SET_TAB';
export const SET_TAB_VALUE = '@search/SET_TAB_VALUE';
export const SET_SEARCH_STATE = '@search/SET_SEARCH_STATE';
//# sourceMappingURL=constants.js.map